import { Result } from 'antd';
import { useLocale } from '../../locales';

const ErrorPage: React.FC = () => {
  const { formatMessage } = useLocale();
  return (
    <Result
      status="warning"
      subTitle={formatMessage({ id: 'global.title.error' })}
    />
  );
};

export default ErrorPage;
